import React, { useEffect, useState } from "react";

//Hooks
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

//State
import { fetchFlows } from "../../state/flows/reducers";
import {
  handleCopyModelFlow,
  handleRemoveProject,
} from "../../state/flows/actions";

//Styles
import {
  ContainerCenter,
  ContainerCenterInside,
  Dashboard,
  DefaultVersionDiv,
  FlowModelItem,
  LastModified,
  MainContainer,
  ModifiedDiv,
  ModifiedDiv2,
  StyledDiv,
  TitleDiv,
  TopDiv,
  Header,
} from "./styles";

import moment from "moment";
import { trackPromise } from "react-promise-tracker";
//Components
import Menu from "../../components/general/Menu";
import TopBar from "../../components/general/TopBar";
import Button from "../../components/general/Button";
import Pagination from "../../components/general/Pagination";
import Input from "../../components/general/Input";
import ConfirmCopyModal from "./ConfirmCopyModal";
import ExcludeFlowModelModal from "./ExcludeFlowModelModal";
import { FilterButton } from "./FilterButton/index";

import { getDashboardFlows, getModelsPage } from "../../state/flows/selectors";
//Icons
import { SearchIcon, TrashIcon, CopyIcon, AddCircleIcon } from "./Icons";
import { toastAlert } from "../../components/Toastify/index";
import ReactLoading from "react-loading";
import { useVerifyToken } from "../../hooks/useVerifyToken";

const ModelFlowsPage = ({ location }) => {
  moment.locale("pt-br");

  const params = new URLSearchParams(location.search);

  const dispatch = useDispatch();
  const history = useHistory();

  const [removeOpen, setRemoveOpen] = useState(false);
  const [copyOpen, setCopyOpen] = useState(false);
  const [flow, setFlow] = useState(null);

  const [openFilterOptions, setOpenFilterOptions] = useState(false);

  // const user = useSelector((state) => state.auth.user);

  const status = useSelector((state) => state.flows.dashboard.status);

  //url Params
  const [titleSearch, setTitleSearch] = useState(
    params.get("title") ? params.get("title") : ""
  ); //filtrar titulo do fluxo

  const [typeFilter, setTypeFilter] = useState({
    alpha: params.get("alpha") ? params.get("alpha") === "true" : false,
    creation: params.get("creation")
      ? params.get("creation") === "true"
      : false,
    page: params.get("page") ? parseInt(params.get("page")) : 1,
  });

  useVerifyToken();

  const updateFilters = ({ alpha = false, creation = false, page = 1 }) => {
    setTypeFilter({ alpha, creation, page });
    setUrlParams({ alpha, creation, page });
  };

  const setUrlParams = ({
    alpha = typeFilter.alpha,
    creation = typeFilter.creation,
    page = 1,
  }) => {
    history.push({
      search:
        "?" +
        new URLSearchParams({
          title: titleSearch,
          alpha,
          creation,
          page,
        }).toString(),
    });
  };

  const handleExcludeConfirm = () => {
    const flowId = flow._id;

    trackPromise(
      dispatch(handleRemoveProject(flowId))
        .then((res) => {
          const title = res.payload?.flow.title;

          toastAlert({ msg: `Projeto '${title}' DELETADO com sucesso` });

          fetchingModelFlows().then(() => {
            setRemoveOpen(false);
          });
        })
        .catch((err) => {
          console.error(err);
          setRemoveOpen(false);
          toastAlert({
            msg: `Houve um ERRO ao DELETAR o projeto '${flow.title}': ${err}`,
            isError: true,
          });
        }),

      "remove-flow"
    );
  };
  const handleExcludeCancel = () => setRemoveOpen(false);

  const handleCopyConfirm = () => {
    const flowId = flow._id;
    const title = flow.title + " Cópia";

    //Trocar Cópia por data string
    trackPromise(
      dispatch(handleCopyModelFlow({ flowId, title }))
        .then((res) => {
          const title = res.data.flow.title;
          toastAlert({ msg: `Projeto '${title}' COPIADO com sucesso!` });
          fetchingModelFlows().then(() => {
            setCopyOpen(false);
          });
        })
        .catch((err) => {
          setCopyOpen(false);
          toastAlert({
            msg: `Houve um ERRO ao COPIAR o projeto '${flow.title}': ${err}`,
            isError: true,
          });
        }),
      "copyModal"
    );
  };

  const handleCopyCancel = () => setCopyOpen(false);

  const flows = useSelector((state) => getDashboardFlows(state));
  // const flowsStatus = useSelector((state) => getDashboardStatus(state));
  const pagesFlow = useSelector((state) => getModelsPage(state));

  async function fetchingModelFlows(newPage = 1) {
    trackPromise(
      dispatch(
        fetchFlows({
          // tenantId: !user?.tenantId ? user?._id : user.tenantId,
          queries: { title: titleSearch, filters: typeFilter },
          page: newPage,
        })
      ).then((err) => {
        if (err.error) {
          toastAlert({
            msg: `Ocorreu um erro ao carregar os projetos: '${err.payload.error}'`,
            isError: true,
          });
        }
      }),
      "fetchModels"
    );
  }

  useEffect(() => {
    fetchingModelFlows(typeFilter.page);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, typeFilter]);

  return (
    <TopDiv>
      <ConfirmCopyModal
        isOpen={copyOpen}
        onClose={handleCopyCancel}
        flowName={flow?.title}
        onConfirm={handleCopyConfirm}
      />
      <ExcludeFlowModelModal
        isOpen={removeOpen}
        onClose={handleExcludeCancel}
        flowName={flow?.title}
        onConfirm={handleExcludeConfirm}
      />
      <Menu />
      <MainContainer>
        <TopBar text="Fluxos Modelos" />
        <ContainerCenter>
          <ContainerCenterInside>
            <Header>
              <StyledDiv>
                <Input
                  value={titleSearch}
                  setValue={setTitleSearch}
                  Icon={() => <SearchIcon />}
                  placeholder="Pesquisar por título..."
                  buttonConfirmText="Pesquisar"
                  buttonConfirm={true}
                  onClickButton={() => {
                    setUrlParams({
                      alpha: typeFilter.alpha,
                      creation: typeFilter.creation,
                    });
                    fetchingModelFlows();
                  }}
                />
              </StyledDiv>
              <Button
                Icon={() => <AddCircleIcon />}
                onClick={() =>
                  history.push({
                    pathname: "/flowpane/creation",
                    state: "creation",
                  })
                }
                content="Novo Fluxo"
                style={{
                  fontFamily: "Sora",
                  width: "10.3rem",
                  position: "absolute",
                  height: "2.68rem",
                  right: "0",
                }}
                marginText="0.45rem"
              />

              <FilterButton
                open={openFilterOptions}
                setOpen={setOpenFilterOptions}
                type={typeFilter}
                setType={updateFilters}
              />
            </Header>
          </ContainerCenterInside>
          <Dashboard>
            {status === "succeeded" ? (
              <>
                {flows.length > 0
                  ? flows.map((item, index) => (
                      <FlowModelItem
                        key={index}
                        onClick={() => {
                          history.push({
                            pathname: "/flowpane/edition",
                            state: "edition",
                            search:
                              "?" +
                              new URLSearchParams({
                                flowId: item._id,
                              }).toString(),
                          });
                        }}
                      >
                        <TitleDiv>{item.title}</TitleDiv>
                        <ModifiedDiv>
                          <div>Última Modificação</div>
                          <LastModified>
                            {moment(item?.createdAt).format("DD/MM/YYYY")}
                          </LastModified>
                        </ModifiedDiv>
                        <ModifiedDiv2>
                          <div>Versão Padrão</div>
                          <DefaultVersionDiv>
                            {item.versionTitle ? item.versionTitle : "Padrão"}
                          </DefaultVersionDiv>
                        </ModifiedDiv2>

                        <Button
                          Icon={() => <TrashIcon />}
                          onClick={(event) => {
                            event.stopPropagation();
                            setFlow(item);
                            setRemoveOpen(true);
                          }}
                          square
                          style={{
                            position: "absolute",
                            right: "1.61%",
                            zIndex: 999,
                          }}
                          size="2.15rem"
                          background="#FFBAAB"
                          colorText="#D93333"
                          activeBackground="#CB9A8F"
                        />
                        <Button
                          Icon={() => <CopyIcon />}
                          textAlign="center"
                          square
                          style={{
                            position: "absolute",
                            right: "6.39%",
                            zIndex: 999,
                          }}
                          onClick={(event) => {
                            event.stopPropagation();
                            setFlow(item);
                            setCopyOpen(true);
                          }}
                          size="2.15rem"
                          activeBackground="#8cadc0"
                          background="#C8D8E1"
                          colorText="#384247"
                        />
                      </FlowModelItem>
                    ))
                  : "VOCÊ NÃO POSSUI FLUXOS CADASTRADOS NO MOMENTO, CRIE UM NA TELA DE CRIAÇÃO DE FLUXOS!!"}
              </>
            ) : (
              <>
                <div>
                  <ReactLoading type="bars" color="#118052" />
                </div>
              </>
            )}
          </Dashboard>

          <Pagination
            style={{
              position: "absolute",
              bottom: "1.5rem",
              left: "50%",
            }}
            actualPage={typeFilter.page}
            onPageChange={(activePage) => {
              updateFilters({
                creation: typeFilter.creation,
                alpha: typeFilter.alpha,
                page: activePage,
              });
            }}
            numberOfPages={pagesFlow}
          />
        </ContainerCenter>
      </MainContainer>
    </TopDiv>
  );
};

export default ModelFlowsPage;
